import styled from 'styled-components'
import {
  Button as ButtonCL,
  Textfield as TextfieldCL
} from 'syf-component-library/ui/atoms'
import { SpinnerLoader as SpinnerLoaderCL } from 'syf-component-library/ui/atoms/Loader'
import { colors } from 'const/colors'
import query from 'mediaQueries'
import Icon from 'ui/atoms/Icon'
import { getTextButtonMarginTopCss, getTextFieldErrorCss } from './helpers'

export const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  background-color: ${colors.white};
  height: 100%;
  @media ${query.greaterThanMedium} {
    flex-direction: row;
  }
`

export const LoginSection = styled.div`
  flex: 1;
`

export const LoginForm = styled.div`
  padding: 0 16px 32px 16px;
  @media ${query.greaterThanSmall} {
    padding: 0 64px 42px 64px;
  }
`

export const Span = styled.span`
  color: ${colors.greyEighty};
`

export const Header = styled.h1`
  font-size: 24px;
  margin: 8px 0 0;
  font-weight: 400;
`

export const ContentText = styled.p<{ maxWidth?: string }>`
  margin: 16px 0;
  max-width: ${({ maxWidth }): string => maxWidth || '400px'};
  color: ${colors.greyEighty};
`

export const AlertBannersContainer = styled.div`
  max-width: 372px;
`

export const FieldContainer = styled.div`
  margin: 24px 0 0;
  & div > label {
    justify-content: flex-start;
  }
  @media ${query.greaterThanTiny} {
    max-width: 320px;
  }
`

export const InputSection = styled.div`
  width: 100%;
  & ${FieldContainer} > div {
    width: 100%;
  }
`

export const TextField = styled(TextfieldCL)<{
  isError: boolean
  isUserIdError?: boolean
}>`
  color: ${colors.darkGrey};
  ${({ isError, isUserIdError }) =>
    (isError || isUserIdError) && getTextFieldErrorCss(isError)};
`

export const TextButton = styled(ButtonCL)<{ marginTop?: string }>`
  display: inline-block;
  margin: ${({ marginTop }) => getTextButtonMarginTopCss(marginTop)};
  padding: 0;
  background-color: ${colors.white};
  text-decoration: underline;
`

export const CheckboxIcon = styled(Icon)`
  color: ${colors.white};
  cursor: pointer;
`

export const ButtonSection = styled.div`
  display: flex;
  justify-content: flex-end;
  max-width: 544px;
`

export const Button = styled(ButtonCL)`
  margin: 0;
  width: 100%;
  @media ${query.greaterThanTiny} {
    width: 180px;
  }
`

export const SpinnerLoader = styled(SpinnerLoaderCL)`
  margin: 0 16px 0 0;
`

export const ClientOfferingContainer = styled.aside`
  display: block;
  width: 100%;
  @media ${query.greaterThanMedium} {
    width: 300px;
  }
`
